export const disableBodyScroll = (stopScrollClass = "overflow-hidden") =>
  typeof window !== "undefined" && window.document.body.classList.add(stopScrollClass);

export const enableBodyScroll = (stopScrollClass = "overflow-hidden") =>
  typeof window !== "undefined" && window.document.body.classList.remove(stopScrollClass);

export const addClassToBody = (classToAdd = "") =>
  typeof window !== "undefined" && window.document.body.classList.add(classToAdd);

export const removeClassFromBody = (classToRemove = "") =>
  typeof window !== "undefined" && window.document.body.classList.remove(classToRemove);

export const downloadBlobAsPDF = ({ data, fileName }) => {
  if (typeof window === "undefined") {
    throw new ReferenceError("window is not defined");
  }
  if (data) {
    const blob = new Blob([data], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(blob);
    const link = document.createElement("a");
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, fileName);
    } else {
      link.download = fileName;
      link.href = fileURL;
      document.body.appendChild(link);
      link.click();
      window.setTimeout(() => {
        URL.revokeObjectURL(fileURL);
        document.body.removeChild(link);
      }, 100);
    }
  }
};

export const downloadBlobAsCSV = ({ data, fileName }) => {
  if (typeof window === "undefined") {
    throw new ReferenceError("window is not defined");
  }
  if (data) {
    const blob = new Blob([data], { type: "text/csv" });
    const fileURL = URL.createObjectURL(blob);
    const link = document.createElement("a");
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, fileName);
    } else {
      link.download = fileName;
      link.href = fileURL;
      document.body.appendChild(link);
      link.click();
      window.setTimeout(() => {
        URL.revokeObjectURL(fileURL);
        document.body.removeChild(link);
      }, 100);
    }
  }
};

export const fetchFileFromUrl = async (url) => {
  let blob = await fetch(url).then((r) => r.blob());
  if (blob) {
    return {
      blob,
      size: blob.size,
      type: blob.type,
      name: url.substring(url.lastIndexOf("/") + 1),
    };
  }
};
